import { React } from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer
      className="bg-light mt-auto"
      style={{ minHeight: "10vh", maxHeight: "10vh", margin: "0" }}
    >
      <ul className="nav justify-content-center border-bottom pt-2 pb-2 mb-3">
        <li className="nav-item">
          <Link to="/" className={"nav-link px-2 text-muted"}>
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/" className={"nav-link px-2 text-muted"}>
            PrivacyPolicy
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/" className={"nav-link px-2 text-muted"}>
            Pricing
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/" className={"nav-link px-2 text-muted"}>
            FAQs
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/" className={"nav-link px-2 text-muted"}>
            Contect
          </Link>
        </li>
      </ul>
      <Link to="/" className={"nav-link text-muted m-0"}>
        <p className="text-center text-muted">
          &copy; 2023 yangdongi.com, All rights reserved.
        </p>
      </Link>
    </footer>
  );
}
export default Footer;
